import { defaultApi } from '@/plugins/api/defaultApi'
import store from '@/store'
let isLoading = false
let isLoaded = false

const st = {
  name: 'choice',
  namespaced: true,
  state: {
    banks: [],
  },
  getters: {
    getBanks(state) {
      store.dispatch(`${st.name}/init`)
      return state.banks
    },
    getBank: (state) => (code) => {
      store.dispatch(`${st.name}/init`)
      return state.banks.find((el) => el.code === code)
    },
  },
  mutations: {
    setBanks(state, banksObj) {
      const banks = []
      for (const k in banksObj) {
        banks.push({
          name: banksObj[k],
          code: k,
        })
      }
      state.banks = banks
    },
  },
  actions: {
    async getBanks({ commit }) {
      const { data } = await defaultApi.getChoicesBanks()
      commit('setBanks', data)
      return data
    },
    async init({ commit, dispatch }) {
      if (isLoading || isLoaded) {
        return false
      }
      try {
        isLoading = true
        await dispatch('getBanks')
        isLoaded = true
      } finally {
        isLoading = false
      }
      return true
    },
  },
}

export default st
